var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VectorIcons"
  }, /*#__PURE__*/React.createElement("path", {
    id: " \xE2\x86\xB3Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.86377e-06C5.37259 5.44316e-06 4.09359e-06 5.37259 4.67297e-06 12C5.25236e-06 18.6274 5.37259 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 4.28438e-06 12 4.86377e-06ZM13.125 7.125C13.125 6.50368 12.6213 6 12 6C11.3787 6 10.875 6.50368 10.875 7.125C10.875 7.7049 11.3138 8.18232 11.8774 8.2434L12.0004 8.25C12.6216 8.24976 13.125 7.74618 13.125 7.125ZM11.2 15.8769L11.2 10.1231C11.2 9.83419 11.5582 9.6 12 9.6C12.4418 9.6 12.8 9.83419 12.8 10.1231L12.8 15.8769C12.8 16.1658 12.4418 16.4 12 16.4C11.5582 16.4 11.2 16.1658 11.2 15.8769Z",
    fill: "#009CDF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ecae9ee420e28bafd521d71b74c6f9d3.svg";
export { ForwardRef as ReactComponent };